import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import HomeIcon from '@mui/icons-material/Home';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { styled } from '@mui/system';
import { useRouter } from 'next/router';
import React, {
  useEffect, useRef, useState,
} from 'react';
import { useAppDispatch, useAppSelector } from '@/utils/hook';
import { setBottomNavigation } from '@/slices/bottomNavigation/slices/bottmNavigationSlices';
import { Tab, Tabs } from '@mui/material';
import { style } from '@/styles/globals';
import { pr } from '@/utils/pxToRem';
import { get } from 'lodash';
import { useSafeLayoutEffect } from '@/utils/hooks/use-safe-layout-effect';

const StyledBottomNavigationTabs = styled(Tabs)`
  position: fixed;
  bottom: 0;
  left:0;
  background: #ffffff;
  width: 100%;
  padding-bottom: ${pr`12px`};
  box-shadow: ${style.boxShadow.customShadow};
  justify-content: space-evenly;
  height:fit-content;
  -webkit-align-items: stretch;
    -webkit-box-align: stretch;
    -webkit-box-direction: normal;
    -webkit-box-orient: vertical;
    -webkit-flex-basis: auto;
    -webkit-flex-direction: column;
    -webkit-flex-shrink: 0;
    align-items: stretch;
    border: 0 solid black;
    box-sizing: border-box;
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    flex-basis: auto;
    flex-direction: column;
    flex-shrink: 0;
    margin-bottom: 0px;
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 0px;
    min-height: 0px;
    min-width: 0px;
    padding-bottom: 0px;
    padding-left: 0px;
    padding-right: 0px;
    padding-top: 0px;
    z-index: 10;
    left: 0px;
  .MuiTabs-flexContainer {
    justify-content: space-evenly;
  }
  .Mui-selected {
    color: ${style.color.product3} !important
  }
`;

const StyledBottomNavigationTabsTabPanel = styled(Tab)`
  font-size: ${style.text.caption.regular.fontSize};
  color: ${style.color.black4};
  text-transform: none;
  .MuiBottomNavigationAction-label {
    font-size: 0.875rem;
  }
  .MuiTab-iconWrapper {
    margin: 0;
  }
`;

export default function AppBottomNavigation() {
  const value = useAppSelector((state) => state.bottomNavigation);
  const dispatch = useAppDispatch();
  const { asPath } = useRouter();
  const [placeholderHeight, setPlaceholderHeight] = useState(0);
  const ref = useRef(null);

  useEffect(() => {
    const height = get(ref.current, 'clientHeight') || 0;
    if (height) {
      setPlaceholderHeight(height);
    }
  }, []);

  useSafeLayoutEffect(() => {
    if (asPath.includes('/my-booking')) {
      dispatch(setBottomNavigation(1));
    } else if (asPath.includes('/account')) {
      dispatch(setBottomNavigation(2));
    } else if (asPath.includes('/lien-he-voi-chung-toi')) {
      dispatch(setBottomNavigation(2));
    } else {
      dispatch(setBottomNavigation(0));
    }
  }, []);

  const { back, push, pathname } = useRouter();
  return (
    <>
      <StyledBottomNavigationTabs
        value={value}
        onChange={(event, newValue) => {
          dispatch(setBottomNavigation(newValue));
        }}
        TabIndicatorProps={{
          style: {
            backgroundColor: 'transparent',
          },
        }}
        ref={ref}
      >
        <StyledBottomNavigationTabsTabPanel
          onClick={() => push('/')}
          label="Trang chủ"
          icon={<HomeIcon fontSize="large" />}
        />
        <StyledBottomNavigationTabsTabPanel
          onClick={() => push('/my-booking')}
          label="Vé của tôi"
          icon={<ConfirmationNumberIcon fontSize="large" />}
        />
        <StyledBottomNavigationTabsTabPanel
          onClick={() => {
            if (pathname.includes('account')) {
              back();
            } else {
              push('/account');
            }
          }}
          label="Tài khoản"
          icon={<AccountCircleIcon fontSize="large" />}
        />
      </StyledBottomNavigationTabs>
      <div style={{
        height: pr(`${placeholderHeight}`),
        background: 'white',
      }}
      />
    </>
  );
}
